<template>
  <section>
    <h3 class="text-center text-xl font-bold text-charcoal-600">What's included:</h3>

    <div class="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-3">
      <div
        v-for="feature in items"
        :key="feature.title"
        class="flex items-start gap-3"
      >
        <div class="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl border border-charcoal-200 bg-charcoal-50">
          <u-icon :name="feature.icon" class="h-6 w-6 text-sage-600" />
        </div>

        <div>
          <h4 class="font-semibold text-charcoal-600 leading-tight">{{ feature.title }}</h4>
          <p class="mt-1 text-sm leading-relaxed text-slate">{{ feature.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
  defineProps({
    items: {
      type: Array,
      required: true
    }
  });
</script>
